import { jsx as _jsx } from "react/jsx-runtime";
// web/src/rendering/components/layouts/Column.tsx
// Vertical stack of render blocks.
import { Renderer } from "../../Renderer";
const GAP = { 2: "gap-2", 3: "gap-3", 4: "gap-4", 6: "gap-6" };
export function Column({ gap = 3, children = [] }) {
    return (_jsx("div", { className: `flex flex-col ${GAP[gap] ?? "gap-3"} mt-3`, children: children.map((child, i) => (_jsx(Renderer, { block: child }, i))) }));
}
